import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';

import TableValue from 'SharedComponents/Fields/ViewMode/TableValue.vue';
import { BaseFieldEmits } from 'SharedComponents/Fields/composables/useBaseFieldProps';
import { useBaseTable } from 'SharedComponents/Fields/composables/useBaseTable';
import { ViewFieldProps } from 'SharedComponents/Fields/composables/useViewField';
import { DynamicTableData, DynamicTableParams, Field } from 'SharedDir/declarations/fields';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'DynamicTableValue' },
  __name: 'DynamicTableValue',
  props: {
    modelValue: {},
    label: {},
    showHistory: { type: Boolean },
    history: {},
    field: {}
  },
  emits: ["reveal-history"],
  setup(__props: any, { emit: __emit }) {



const props = __props;
const emits = __emit;

const headers = computed(() => props.field.params.cols.headers);
const columns = computed(() => props.field.params.cols.columns);
const rows = computed(() => props.modelValue.value ?? []);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TableValue, {
    headers: headers.value,
    columns: columns.value,
    label: _ctx.label,
    rows: rows.value
  }, null, 8, ["headers", "columns", "label", "rows"]))
}
}

})